module.exports = __webpack_public_path__ + "favicon.21fb73f6f7e5d1cffc8536d3b293a924.ico";